import { render, staticRenderFns } from "./InputTextMailFromWhiteListSimpleDialog.vue?vue&type=template&id=4faaac28&"
import script from "./InputTextMailFromWhiteListSimpleDialog.vue?vue&type=script&lang=js&"
export * from "./InputTextMailFromWhiteListSimpleDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports